import React from 'react'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import Header from '../common/Header'
import SideMenu from '../common/SideMenu'
import Tr from './Tr';

import './Oripa.css'
import CommonModal from '../common/Modal/CommonModal'

import { useTranslation } from "react-i18next";

const NewOripaConfirm = ({moveNewOripaSelectCard, moveNewOripaConfirmCancelHandler, packageInfo, packageTypeList, cardNumber, setCardNumber, cardList, setCardList}) => {
  const { t } = useTranslation();
  const {shop} = useParams();

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalImageIsOpen, setModalImageIsOpen] = useState([false, '']);
  const [cardSetting, changeCardSetting] = useState(false);

  const showCardSettingHandler = () => {
    changeCardSetting(true);
  }

  const hideCardSettingHandler = () => {
    changeCardSetting(false);
  }

  const openModal = () => {
    setModalIsOpen(true);
  }

  const openImageModal = (e) => {
    e.preventDefault();
    
    setModalImageIsOpen([true, e.target.src]);
  }

  const closeImageModal = () => {
    setModalImageIsOpen([false, '']);
  }

  const CreateCardList = () => {
    return cardList.map((card) => {
      return <Tr oripa={card} openModal={openModal} openImageModal={openImageModal} cardNumber={cardNumber} confirmPackage={true} key={"card"+card.id} />
    })
  }

  const setEnabled = () => {
    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
        xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
        token = token.split('=')[1]
    }

    fetch(`${process.env.REACT_APP_API_URL}/api/package/enable/${packageInfo.packageId}`, {
      method: 'GET',
      headers: {
        'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
        'Bearer': decodeURIComponent(token),
      },
      credentials: 'include',
    })
    .then(response => {
      if (response.ok) {
        openModal();
      } else {
        alert(t('common.error'));
      }
    })
    .catch(error => {
      alert(t('common.error'));
    });
  }

  const [totalRefundPoint, setTotalRefundPoint] = useState(0);

  useEffect(() => {
    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
        xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
        token = token.split('=')[1]
    }

    fetch(`${process.env.REACT_APP_API_URL}/api/package-cards/${packageInfo.packageId}`, {
      headers: {
        'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
        'Bearer': decodeURIComponent(token)
      },
      credentials: 'include',
    })
    .then(response => response.json())
    .then(data => {
      if(!data.errors) {
        if (data.package_cards) {
          setCardNumber(data.package_cards.filter((card) => card.rank != 9).map((card) => card.number).reduce((a, b) => a + b, 0));
          setCardList(data.package_cards.map((card) => {
            return {
              url: process.env.REACT_APP_ASSET_URL + card.image_url,
              name: card.name,
              rank: card.rank,
              number: card.number,
              stock: card.stock,
              rewardPoint: card.point,
              id: card.id,
              card_id: card.card_id,
              psa: card.psa,
              isPsaEnabled: card.is_psa_enabled,
            }
          }))
          setTotalRefundPoint(data.package_cards.map((card) => card.rank == 9 ? card.point : card.number * card.point).reduce((a, b) => a + b, 0));
        }
      }
    })
  }, [])

  let {id} = useParams();

  if (!id) {
    id = packageInfo.packageId;
  }

  return (
    <>
      <Header />
      <SideMenu />
      <div className="oripa">
        <div className="oripa-content">
          {!id ?
            <div className="oripa-title">{t('new_oripa_confirm.oripa')}</div>
            :
            <div className="oripa-title">{t('new_oripa_confirm.stock')}</div>
          }
          <div className='clearfix'></div>
          <ul className="progressbar">
            <li className="active"></li>
            <li className="active"></li>
            <li className="active">{t('new_oripa_confirm.confirm')}</li>
          </ul>
          <div className='clearfix'></div>
          <div className='clearfix'></div>
          <dl className="oripa-info-confirm oripa-info-confirm-half">
            <dt className="oripa-info-confirm-title clear-left">{t('new_oripa_confirm.kind')}</dt>
            <dd className="oripa-info-confirm-text">
              {packageTypeList.map((packageType, index) => {
                    if (packageInfo.packageType.toString() === packageType.package_type) {
                      return (
                        t('package_master.' + packageType.package_type_name)
                      )
                    }
                  })}
            </dd>
            <dt className="oripa-info-confirm-title clear-left">{t('new_oripa_confirm.oripa_name')}</dt>
            <dd className="oripa-info-confirm-text">{packageInfo.packageName}</dd>
            <dt className="oripa-info-confirm-title clear-left">{t('new_oripa_confirm.price')}</dt>
            <dd className="oripa-info-confirm-text">{packageInfo.packagePrice} {t('new_oripa_confirm.yen')}</dd>
            <dt className="oripa-info-confirm-title clear-left">{t('new_oripa_confirm.setting')}</dt>
            <dd className="oripa-info-confirm-text">{cardNumber} {t('new_oripa_confirm.card')}</dd>
            <dt className="oripa-info-confirm-title clear-left">{t('new_oripa_confirm.period')}</dt>
            <dd className="oripa-info-confirm-text">{packageInfo.packageStartAt} 〜 {packageInfo.packageEndAt}</dd>
            <dt className="oripa-info-confirm-title">{t('new_oripa_confirm.total_points')}</dt>
            <dd className="oripa-info-confirm-text">{totalRefundPoint.toLocaleString()}pt</dd>
          </dl>
          <dl className="oripa-info-confirm">
            <dt className="oripa-info-confirm-title">{t('new_oripa_confirm.pop')}</dt>
              <dd className="oripa-info-confirm-text oripa-info-confirm-text-img">
                <img src={packageInfo.packageImage} className="oripa-info-confirm-image" onClick={openImageModal}/>
            </dd>
            <dt className="oripa-info-confirm-title">{t('new_oripa_confirm.pop_en')}</dt>
              <dd className="oripa-info-confirm-text oripa-info-confirm-text-img">
                {packageInfo.packageImageEn && <img src={packageInfo.packageImageEn} className="oripa-info-confirm-image" onClick={openImageModal}/>}
            </dd>
            <dt className="oripa-info-confirm-title">{t('new_oripa_confirm.pop_jp')}</dt>
              <dd className="oripa-info-confirm-text oripa-info-confirm-text-img">
                {packageInfo.packageImageJp && <img src={packageInfo.packageImageJp} className="oripa-info-confirm-image" onClick={openImageModal}/>}
            </dd>
          </dl>
          <div className='clearfix'></div>
          <div className="oripa-info-sub-title">{t('new_oripa_confirm.card_setting')}</div>
          {!cardSetting ? 
            <>
              <button className="oripa-info-close-button" onClick={showCardSettingHandler}>{t('new_oripa_confirm.open')}</button>
              <div className='clearfix'></div>
              <div className='line2'></div>
            </>
            :
            <>
              <button className="oripa-info-close-button" onClick={hideCardSettingHandler}>{t('new_oripa_confirm.close')}</button>
              <div className='clearfix'></div>
              <div className='line2'></div>
              <div className="oripa-content-table">
                <table className="oripa-content-table">
                  <thead>
                    <tr>
                      <th>{t('new_oripa_confirm.image')}</th>
                      <th>{t('new_oripa_confirm.name')}</th>
                      <th>{t('new_oripa_confirm.rank')}</th>
                      <th>{t('new_oripa_confirm.cards')}</th>
                      <th>{t('new_oripa_confirm.points')}</th>
                      <th>PSA</th>
                      <th>{t('new_oripa_confirm.probability')}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <CreateCardList />
                  </tbody>
                </table>
              </div>
            </>
          }
          <div className="oripa-info-button">
            <button className="oripa-info-button-back" onClick={moveNewOripaConfirmCancelHandler}>{t('new_oripa_confirm.back')}</button>
            <a href={`/${shop}/oripa/${id}/preview`} target="_blank">
              <button className="oripa-info-button-next">{t('new_oripa_confirm.preview')}</button>
            </a>
            <button className="oripa-info-button-next" onClick={setEnabled}>{t('new_oripa_confirm.next')}</button>
          </div>
        </div>
      </div>
      <CommonModal
        modalIsOpen={modalIsOpen}
        message={t('new_oripa_confirm.complete')}
        linkMessage={t('new_oripa_confirm.top')}
        link={`/${shop}/stock`}
      ></CommonModal>
    </>
  )
}

export default NewOripaConfirm